import { type } from '@/utils/type'


//////////////////////////////////////////////////////////////////
// CLIENT
/////////////////////////////////////////////////////////////////

export const CLIENT_CHECKOUT_SUCCESS =  type('CLIENT_CHECKOUT_SUCCESS')
export const CLIENT_CHECKOUT_ERROR =  type('CLIENT_CHECKOUT_ERROR')

export const CLIENT_CHECKOUT_FREE_SUCCESS =  type('CLIENT_CHECKOUT_FREE_SUCCESS')
export const CLIENT_CHECKOUT_FREE_ERROR =  type('CLIENT_CHECKOUT_FREE_ERROR')



